import React from "react"

const RenderThumbnailPicture = ({
  avifImage,
  webpImage,
  pngImage,
}) => (
  <picture>
    <source
      srcSet={avifImage}
      type="image/avif"
      alt=""
    />
    <source
      srcSet={webpImage}
      type="image/webp"
      alt=""
    />
    <img src={pngImage} alt="" />
  </picture>
)

export default RenderThumbnailPicture
